var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopilot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.2c-1 0-1.9.9-1.9 2 0 .3.1.6.3.8l-1.1 1.1H8.4V5.7h1.4a2 2 0 0 0 3.7-.9c0-1-.9-1.9-2-1.9a2 2 0 0 0-1.8 1.3H8.4v-.1a3 3 0 0 0-6 0v.4A3 3 0 0 0 .6 9.2 3 3 0 0 0 2.4 14a3 3 0 0 0 6-.4H11a2 2 0 0 0 3.7-.8c0-1-.9-1.9-2-1.9a2 2 0 0 0-1.7 1.2H8.4V9.5h5.4L15.4 8h.7c1 0 1.9-.8 1.9-1.8s-.9-2-2-2zm-4.4.1c.2 0 .5.2.5.5s-.3.5-.5.5-.5-.2-.5-.5.2-.5.5-.5zM7 13.6c0 .9-.7 1.6-1.6 1.6-.8 0-1.5-.6-1.6-1.4l-.1-1-1-.2c-.7-.2-1.3-.8-1.3-1.6 0-.4.2-.7.3-1l.7-.8-.7-.8c-.1-.2-.3-.5-.3-1C1.4 6.7 2 6 2.7 6l1.1-.3V4.1A1.6 1.6 0 1 1 7 4v9.5zm5.8-1.3c.3 0 .5.2.5.5s-.2.5-.5.5a.5.5 0 0 1-.5-.5c0-.3.2-.5.5-.5zM16 6.7a.5.5 0 0 1-.5-.5c0-.3.2-.6.5-.6.2 0 .5.3.5.6 0 .2-.3.5-.5.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopilot);
export default __webpack_public_path__ + "static/media/copilot.45dfed48.svg";
export { ForwardRef as ReactComponent };